import React from 'react';

const CircularGauge = ({ 
  value, 
  max = 100, 
  size = 120, 
  strokeWidth = 8, 
  title, 
  color = '#22C55E',
  backgroundColor = '#E5E7EB',
  showValue = true,
  unit = '%'
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (value / max) * circumference;

  const center = size / 2;

  return (
    <div className="flex flex-col items-center">
      {title && (
        <h3 className="text-sm font-medium text-gray-600 mb-2 text-center">{title}</h3>
      )}
      
      <div className="relative">
        <svg width={size} height={size} className="transform -rotate-90">
          {/* Background circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="transparent"
            stroke={backgroundColor}
            strokeWidth={strokeWidth}
          />
          
          {/* Progress circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="transparent"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            className="transition-all duration-700 ease-out"
          />
        </svg>
        
        {showValue && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <div className="text-2xl font-bold" style={{ color }}>
                {value?.toFixed?.(1) || value}{unit}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CircularGauge;